import React from 'react';
import Link from '../Link/Link';
var HeaderMenu = function (props) {
    var _a = props.mobileVisible, mobileVisible = _a === void 0 ? true : _a, _b = props.hideMenu, hideMenu = _b === void 0 ? false : _b, _c = props.routes, routes = _c === void 0 ? [] : _c, _d = props.mobileItems, mobileItems = _d === void 0 ? [] : _d, onCloseMenu = props.onCloseMenu;
    var createRoute = function (route, index) { return (React.createElement("li", { id: "" + index, key: index, className: "o-header-item" },
        React.createElement(Link, { className: "o-header-link", activeClassName: "active", to: route.path ? route.path : '/' },
            route.iconClass ? (React.createElement("i", { className: "fal fa-" + route.iconClass })) : null,
            route.name))); };
    var createMobileRoute = function (items) { return (React.createElement("li", { className: "o-header-item header-item-responsive" },
        React.createElement("ul", { className: "mobile-actions" }, items.map(function (route, index) {
            return createRoute(route, index);
        })))); };
    return (React.createElement("ul", { className: "o-header-links" + (mobileVisible ? ' show' : '') }, !hideMenu && (React.createElement(React.Fragment, null,
        React.createElement("li", null,
            React.createElement("button", { "aria-label": "Close menu", className: "o-header-dropdown-close", onClick: onCloseMenu },
                "CLOSE",
                React.createElement("i", { className: "fal fa-times" }))),
        mobileItems.length ? createMobileRoute(mobileItems) : null,
        routes.map(function (route, index) { return createRoute(route, index); })))));
};
export default HeaderMenu;
